import * as Sentry from "@sentry/react-native";

/**
 * If running the application in development mode this function asserts the provided data
 * matches the schema provided. If the data does not match the schema an error is thrown,
 * but only in development mode. In production mode the error is caught and sent to Sentry.
 *
 * Example usage
 *
 *     const schema = z.object({ name: z.string() });
 *     const data: any = await getData();
 *     assertSchema(data, schema); // This throws in development mode if data does not match the schema
 *     data.name; // string
 *
 * @param data Input data to be validated by the zod schema
 * @param schema Zod schema describing the shape of the data
 * @asserts data is the shape described by the schema
 * @returns void
 */
export function assertSchema<Output>(
  data: unknown,
  schema: { parse: (data: unknown) => Output },
): asserts data is Output {
  if (__DEV__) {
    schema.parse(data);
  } else {
    try {
      schema.parse(data);
    } catch (error) {
      Sentry.captureException(error);
    }
  }
}
